import createUiAction from '../create-ui-action';

export const initializeEditor = createUiAction(
  'editor/initialize',
  (name, initialState) => ({ name, initialState }),
);

export const closeEditor = createUiAction('editor/close', name => ({ name }));
